/**
 * Results Page JS
 * -----------------------------------------------------------------------------
 *
 * All the JS for the Results Page component.
 */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      $( '.results__menu-type' ).on( 'click', function() {
        $( this ).next().slideToggle();
      } );

      const mediaQuery = window.matchMedia( '(max-width: 769px)' );

      if ( mediaQuery.matches ) {
        $( '.mobile-filter__button' ).on( 'click', ( event ) => {
          $( $( event.target ).attr( 'data-toggle-attr' ) ).toggleClass( 'is-open' );
        } );
      }

      $( document ).ready( function() {
        $( '.results__menu-mobile-heading button' ).on( 'click', function() {
          if ( !$( this ).hasClass( 'is-open' ) ) {
            $( this ).removeClass( 'is-open' );

            $( '.results__page-wrapper' ).removeClass( 'is-open' );
          }
        } );
      } );

      $( document ).ready( function() {
        const pageNumbers = document.querySelectorAll( '.results__pagination .page-numbers' );

        // Check if there are any elements with the 'page-numbers' class
        if ( pageNumbers.length > 0 ) {
        // Remove 'prev' class from the first element
          const firstPageNumber = pageNumbers[0];
          if ( firstPageNumber.classList.contains( 'prev' ) ) {
            firstPageNumber.classList.remove( 'prev' );
          }

          // Remove 'next' class from the last element
          const lastPageNumber = pageNumbers[pageNumbers.length - 1];
          if ( lastPageNumber.classList.contains( 'next' ) ) {
            lastPageNumber.classList.remove( 'next' );
          }
        }

        const $filterForm = $( '#treatment-filter' );

        function updateUrlAndFetchResults( pageNumber = 1 ) {
          const selectedFilters = $filterForm.serializeArray();
          const filterParams = selectedFilters.reduce( ( acc, filterItem ) => {
            if ( filterItem.name === 'result_treatment[]' ) {
              acc.result_treatment.push( filterItem.value );
            } else if ( filterItem.name === 'results_provider[]' ) {
              acc.results_provider.push( filterItem.value );
            }
            return acc;
          }, {result_treatment: [], results_provider: []} );

          const queryString = $.param( {
            result_treatment: filterParams.result_treatment.join( ',' ),
            results_provider: filterParams.results_provider.join( ',' ),
            paged: pageNumber,
          } );

          const baseUrl = window.location.href.split( '?' )[0];
          const newUrl = `${baseUrl}?${queryString}`;

          history.pushState( {page: pageNumber}, '', newUrl );

          $.ajax( {
            type: 'GET',
            url: newUrl,
            success: function( responseHtml ) {
              const resultsGridHtml = $( responseHtml ).find( '.ajax-results' );
              const paginationHtml = $( responseHtml ).find( '.results__pagination' );
              $( '.ajax-results' ).replaceWith( resultsGridHtml );
              $( '.results__pagination' ).replaceWith( paginationHtml );
            },
            error: function( xhr, status, error ) {
              console.error( 'AJAX request failed:', status, error );
            },
          } );
        }

        $( document ).on( 'change', '.results__sub-menu input[type="checkbox"]', function() {
          updateUrlAndFetchResults();
        } );

        $( document ).on( 'click', '.results__pagination a', function( event ) {
          event.preventDefault();
          const pageNumber = $( this ).text();
          updateUrlAndFetchResults( pageNumber );
        } );

        window.onpopstate = function( event ) {
          if ( event.state && event.state.page ) {
            updateUrlAndFetchResults( event.state.page );
          }
        };

        const urlParams = new URLSearchParams( window.location.search );
        const pageNumber = urlParams.get( 'paged' ) || 1;
        updateUrlAndFetchResults( pageNumber );
      } );
    },
    finalize: function() {},
  };

  // Hooks the component into the app
  app.registerComponent( 'results-page', COMPONENT );
} )( app );
